module.exports = __webpack_public_path__ + "img/4right-1a5e26b4.png";